import { generateScopedActionCreator } from '@synthetica-ai/system';

const { createAction } = generateScopedActionCreator('UI');

export const openDialog = createAction('OPEN_DIALOG');
export const closeDialog = createAction('CLOSE_DIALOG');

export const openSnackbar = createAction('OPEN_SNACKBAR');
export const closeSnackbar = createAction('CLOSE_SNACKBAR');
